import { useRef, useEffect, useState } from 'react';
import style from './Sec03.module.css';
import secImg01 from '../images/sec03_img01.png'
import secImg02 from '../images/sec03_img02.png'
import secImg03 from '../images/sec03_img03.png'
import secImg04 from '../images/sec03_img04.png'
import secIco01 from '../images/sec03_ico01.png'
import secIco02 from '../images/sec03_ico02.png'
import secIco03 from '../images/sec03_ico03.png'
import secIco04 from '../images/sec03_ico04.png'


function Sec03( {sec03Ref} ) {

    return (
        <div className={style.wrap} ref={sec03Ref}>
            <div className={style.tit_box}>
                <h4>
                    축적된 경험과 기술력으로<br />
                    <span>완성도 높은</span> 제품을 제공합니다.
                </h4>
            </div>
            <div className={style.item_box}>
                <div className={`${style.item_container} ${style.item_container01}`}>
                    <div className={`${style.item} ${style.item01}`}>
                    <div className={style.item_wrap}>
                        <div className={style.img_box}>
                            <img src={secImg01} alt='니코틴 제조 및 생산' />
                        </div>
                        <div className={style.hover_box}>
                            <div className={style.hover_txt}>
                                <h5>니코틴 제조 및 생산</h5>
                                <p>
                                    국내 유일한 합성 S 니코틴
                                    제조사로서 엄격한 규정을
                                    기반으로 제조하고 있습니다.
                                </p>
                            </div>
                            <div className={style.hover_ico}>
                                <img src={secIco01} alt='니코틴 제조 및 생산' />
                            </div>
                        </div>
                    </div>

                    <div className={style.item_tit}>
                        <h5>니코틴 제조 및 생산</h5>
                    </div>
                </div>
                <div className={`${style.item} ${style.item02}`}>
                    <div className={style.item_wrap}>
                        <div className={style.img_box}>
                            <img src={secImg02} alt='OEM 생산' />
                        </div>
                        <div className={style.hover_box}>
                            <div className={style.hover_txt}>
                                <h5>OEM 생산</h5>
                                <p>
                                    신뢰와 기술력을 바탕으로
                                    준비된 재료에 니코틴 및
                                    기본공정 작업을 진행합니다.
                                </p>
                            </div>
                            <div className={style.hover_ico}>
                                <img src={secIco02} alt='OEM 생산' />
                            </div>
                        </div>
                    </div>

                    <div className={style.item_tit}>
                        <h5>OEM 생산</h5>
                    </div>
                </div>
                </div>
                <div className={`${style.item_container} ${style.item_container02}`}>
                    <div className={`${style.item} ${style.item03}`}>
                    <div className={style.item_wrap}>
                        <div className={style.img_box}>
                            <img src={secImg03} alt='ODM 생산' />
                        </div>
                        <div className={style.hover_box}>
                            <div className={style.hover_txt}>
                                <h5>ODM 생산</h5>
                                <p>
                                    뛰어난 제품 개발력과 자체생산
                                    기술로 누구나 만족할 맞춤형
                                    액상을 제작합니다.
                                </p>
                            </div>
                            <div className={style.hover_ico}>
                                <img src={secIco03} alt='ODM 생산' />
                            </div>
                        </div>
                    </div>

                    <div className={style.item_tit}>
                        <h5>ODM 생산</h5>
                    </div>
                </div>
                <div className={`${style.item} ${style.item04}`}>
                    <div className={style.item_wrap}>
                        <div className={style.img_box}>
                            <img src={secImg04} alt='자사제품' />
                        </div>
                        <div className={style.hover_box}>
                            <div className={style.hover_txt}>
                                <h5>자사제품</h5>
                                <p>
                                    우리만의 기술로 품질과
                                    경쟁력을 갖춘 독보적인 액상을
                                    만들고 있습니다.
                                </p>
                            </div>
                            <div className={style.hover_ico}>
                                <img src={secIco04} alt='자사제품' />
                            </div>
                        </div>
                    </div>

                    <div className={style.item_tit}>
                        <h5>자사제품</h5>
                    </div>
                </div>
                </div>
                
            </div>
        </div>
    )
}

export default Sec03;